export default __webpack_public_path__ + "static/media/financialAsset.1e723d8b.svg";